<script>

const config = require('@/config.js')[ process.env.NODE_ENV || 'local' ];

export default {

    name: 'item-email',
    props: [ 'item' ],
    data() {
        return {
            data: {
            }
        }
    },
    computed: {
        backend_url() { return config.backend_url; },
        viewer_url() { return config.viewer_url; },
        validated_by_node() {
            return this.item.config.send_error === null && this.item.config.hasOwnProperty('node_response') && this.item.config.node_error === null;
            //return true;
        },
        code() {
            return this.item.config.node_response.code;
            //return 'robe-a-caso';
        },
        sent() {
            return this.item.config.email;
            //return false;
        },
        mail_to() {
            return `mailto:${ this.item.email }?subject=[${ this.item.company.label }] Certificato rilasciato&body=Spettabile ${ this.item.first_name } ${ this.item.last_name },%0D%0Ala informiamo che il certificato del corso ${ this.item.title } da lei frequentato è disponibile a questo indirizzo:%0D%0A%0D%0A${ this.viewer_url }${ this.code }%0D%0A%0D%0ACordiali saluti,%0D%0A${ this.item.company.label }`;
        },
    },
    methods: {
        set_sent() {
            this.$store.dispatch( 'item/set_email_sent', { email: true, id: this.item.id } );
        },
    },
    created() {},

}

</script>

<template>

    <span v-if="validated_by_node === false" style="opacity: 0.6">
        <icon name="envelope"/>
    </span>

    <a v-else-if="validated_by_node && sent === false" @click="set_sent" size="sm" variant="light" :href="mail_to" target="_blank">
        <icon name="envelope"/>
    </a>

    <span v-else-if="sent === true" style="color: #28a745">
        <icon name="envelope"/>
    </span>

</template>

